import { render } from "./PromotionItem.vue?vue&type=template&id=9f8b0128&scoped=true"
import script from "./PromotionItem.vue?vue&type=script&lang=js"
export * from "./PromotionItem.vue?vue&type=script&lang=js"

import "./PromotionItem.vue?vue&type=style&index=0&id=9f8b0128&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8b0128"]])

export default __exports__